import React from 'react'
import { TouchableOpacity, View, Image, Text, StyleSheet, GestureResponderEvent } from 'react-native'
import PropTypes from 'prop-types'
import { QuestionRadioButton } from './question-radio-button'
import { QuestionText } from './question-text'
import { QuestionImage } from './question-image'
import { QuestionAttributes } from '../types/attributes'

type QuestionProps = {
  /** The id of the question node. */
  id: string,
  /** The primary color of the question component. */
  accentColor: string,
  /** true if the component is selected. */
  active?: boolean,
  /** The question name. */
  name: string,
  /** 
   * The type of node it is.
   * See propTypes in the source for options
   */
  type?: string,
  /** The attributes in the node. Look at the app-editor for more. */
  attributes: QuestionAttributes,
  /** The question has been clicked handler. */
  onClick: Function,
}

/**
 * A questions answer option.
 * @component
 */
export const Question = ({id, accentColor, active, name, type, attributes, onClick}: QuestionProps) => {

  const onRadioPress = (e: GestureResponderEvent) => {
    onClick(id)
  }

  return (
    <TouchableOpacity
      onPress={onRadioPress}
      style={styles.container}
    >
      <View style={styles.touchablContainer}>
        <QuestionRadioButton accentColor={accentColor} active={active} />
        {
          (type === 'image-question' || type === 'title-&-image') && attributes?.image &&
          <QuestionImage name={name} image={attributes?.image} />
        }
        {
          type !== 'image-question' &&
          type !== 'title-&-image' &&
          <QuestionText name={name} />
        }
      </View>
    </TouchableOpacity>
  )
}

Question.propTypes = {
  id: PropTypes.string.isRequired,
  accentColor: PropTypes.string,
  active: PropTypes.bool,
  name: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['text-question', 'image-question', 'title-only', 'title-&-image', 'leaf']),
  attributes: PropTypes.object,
  onClick: PropTypes.func.isRequired,
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    borderRadius: 60,
    width: '90%',
    margin: 5,  
  },
  touchablContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
})
